import { OnboardingStep } from '@/data/user-invite';
import { RouteName, RouteNames } from '@/data/routes';
import { useStore } from 'vuex';
import { computed } from 'vue';
import router from '@/routes';
import { useDocumentUploads } from './useDocumentUploads';
import { getOnboardingCompletionRoute } from '@/utils/router-helper';

export const getAdjacentInvitedUserOnboardingRoutes = () => {
  const store = useStore();

  const { areDocumentUploadsHidden } = useDocumentUploads();

  const invitedUserOnboardingSteps = computed<Record<string, OnboardingStep>>(
    () => store.getters.invitedUserOnboardingSteps,
  );

  const currentRoute = computed(
    () => router.currentRoute.value.name as RouteName,
  );

  const currentStep = invitedUserOnboardingSteps.value[currentRoute.value];

  if (!currentStep) {
    return {
      fallbackRouteName: RouteNames.HOME.INITIAL,
    };
  }

  const businessProfileSteps = store.getters.businessProfileSteps;

  switch (currentStep.name) {
    case RouteNames.ONBOARDING.INVITED.USER_DETAILS:
      return {
        nextRouteName: RouteNames.ONBOARDING.INVITED.VERIFICATION,
        previousRouteName: null,
      };
    case RouteNames.ONBOARDING.INVITED.VERIFICATION:
      const nextRouteName = areDocumentUploadsHidden.value
        ? RouteNames.ONBOARDING.INVITED.REVENUE_ACCOUNT
        : RouteNames.ONBOARDING.INVITED.ID;

      return {
        nextRouteName,
        previousRouteName: RouteNames.ONBOARDING.INVITED.USER_DETAILS,
      };
    case RouteNames.ONBOARDING.INVITED.ID:
      return {
        nextRouteName: RouteNames.ONBOARDING.INVITED.REVENUE_ACCOUNT,
        previousRouteName: RouteNames.ONBOARDING.INVITED.VERIFICATION,
      };
    case RouteNames.ONBOARDING.INVITED.REVENUE_ACCOUNT:
      return {
        nextRouteName: getOnboardingCompletionRoute(businessProfileSteps),
        previousRouteName: areDocumentUploadsHidden.value
          ? RouteNames.ONBOARDING.INVITED.VERIFICATION
          : RouteNames.ONBOARDING.INVITED.ID,
      };
    default:
      return {
        fallbackRouteName: RouteNames.HOME.INITIAL,
      };
  }
};

export function useInvitedUserRouting() {
  return {
    getAdjacentInvitedUserOnboardingRoutes,
  };
}
